<template>
  <!-- <v-card class="rigt_navbar" style="padding-left:0px"> -->
  <v-card class="overflow-hidden v-card v-sheet theme--light m-0">
    <div>
      <v-alert
        :type="alert_type"
        :model-value="alert"
        :value="alert"
        transition="scale-transition"
        >{{ alert_message }}</v-alert
      >
    </div>

    <!-- start -->
    <!-- <div class="main_header" style="margin-left:16px;margin-top:16px">
      Insurance
    </div> -->
    <div><HeaderComponent headerTitle="User Control" /></div>
    <v-card-title class="action-style pb-0">
    <v-row class="ml-0 mx-3 my-3 mb-0">
      <v-text-field
        prepend-inner-icon="mdi-magnify"
        v-model="search"
        label="Search By Email"
        variant="outlined"
        style="max-width: 270px;"
        v-on:keyup.enter="searchItem()"
      ></v-text-field>
      <v-spacer></v-spacer>
      <v-card-actions style="margin-bottom: 28px;">
        <v-layout align-center>
          <v-btn class="mr-2 text-white text-none" size="x-large" variant="flat" color="primary" >Update From File</v-btn>
          <router-link :to="{ name: 'NewUser' }">
            <v-btn class="mr-2 text-white text-none" size="x-large" variant="flat"color="primary" >Create New User</v-btn>
          </router-link>
        </v-layout>
      </v-card-actions>
    </v-row>
    </v-card-title>

    <v-layout column class="select-card">
      <v-col cols="12" sm="6" md="12" class="pa-0 pb-3">
        <v-data-table hover
          density="compact"
          :search="search"
            v-model="selected"
            disable-pagination
          :hide-default-footer="true"
          :headers="headers"
          :items="table_data"
          :height="minTableHeight"
          fixed-header
          :loading="loading"
          :items-per-page="pageSize"
          return-object
          loading-text="Loading Data... Please wait"
          class="elevation-1"
        >
        <template v-slot:[`item.${headers.key}`]="{ item }" v-for="headers in headers">
             <span v-if="headers.key == 'user_status'">
              <v-chip
              class="ma-2 justify-center"
              size="small"
              variant="flat" 
              label
              :color="getColor(item.status)"
              style="min-width: 80px"
              dark
              >{{ item.status }}</v-chip
            ></span>
              <span v-else-if="headers.key == 'view'">
                <router-link
              :to="{ name: 'EditUser', params: { id: item.id } }"
              v-if="
                item.role_name != 'central_admin' ||
                currentUser.roles.includes('central_admin')">
              <img
                src="@/assets/images/job_sheet.png"
                title="Edit User"
              />
            </router-link>
          </span>
              <span v-else-if="headers.key !== 'imags' && item[headers.key]">
                <span v-tooltip="item[headers.key]">
                  {{ item[headers.key].length > 20 ? item[headers.key].slice(0, 20) + '...' : item[headers.key] }}
                </span>
              </span>
              <span v-else>-</span>
            </template>
          <!-- <template #[`item.user_status`]="{ item }">
            <v-chip
              class="ma-2 justify-center"
              size="small"
              variant="flat" 
              label
              :color="getColor(item.status)"
              style="min-width: 80px"
              dark
              >{{ item.status }}</v-chip
            >
          </template> -->
          <!-- <template #[`item.view`]="{ item }">
            <router-link
              :to="{ name: 'EditUser', params: { id: item.id } }"
              v-if="
                item.role_name != 'central_admin' ||
                currentUser.roles.includes('central_admin')
              "
            >
              <img
                src="@/assets/images/job_sheet.png"
                title="Edit User"
              />
            </router-link>
          </template> -->
          <!-- <template #[`item.employee_id`]="{ item }">
            <span>{{ item.employee_id ? item.employee_id : '-' }}</span>
          </template> -->
          <template #bottom></template>
        </v-data-table>
      </v-col>
    </v-layout>
    <PaginationComponent
                    :pageSize="pageSize"
                    :pageSizes="pageSizes"
                    :totalCount="totalCount"
                    :selected="selected"
                    :page="page"
                    :totalPages="totalPages"
                    @update:pageSize="handlePageSizeChange"
                    @update:page="handlePageChange"
                    class="mt-2 mb-0"
                />
  </v-card>
</template>

<script>
import Editor from "@tinymce/tinymce-vue";
import { mapState } from "vuex";
import { defaultPageSize, defaultPageSizes } from '@/components/commoncomponents/PaginationComponent.vue';
import HeaderComponent from "./../../../commoncomponents/HeaderComponent";
export default {
  data() {
    return {
      loading: false,
      alert: false,
      search: "",
      disposition: [],
      selected: [],
      dialog: false,
      alert_type: "",
      headers: [
        {
          title: "User Name",
          align: "start",
          key: "username",
          minWidth:"200px"
        },
        { title: "User Email", key: "email", minWidth:"200px" },
        { title: "Employee Code", key: "employee_id", minWidth:"200px" },
        { title: "User Mobile Number", key: "contact_no", minWidth:"200px" },
        { title: "Status", key: "user_status", minWidth:"200px" },
        { title: "Action", key: "view", minWidth:"200px" },
      ],
      table_data: [],
      page: 1,
      totalPages: 1,
      totalCount: '',
      pageSize: defaultPageSize,
      pageSizes: defaultPageSizes,
    };
  },
  computed: mapState(["currentUser", "signedIn"]),
  created() {
    this.getUserData();
  },
  components: {
    editor: Editor,
    HeaderComponent,
  },
  methods: {
    alertTimeOut() {
      setTimeout(() => {
        this.alert = false;
      }, 3000);
    },

    getRequestParams(page, pageSize) {
      let params = {};
      if (page) {
        params["page"] = page;
      }

      if (pageSize) {
        params["size"] = pageSize;
      }

      return params;
    },

    handlePageChange(value) {
      this.page = value;
      this.getUserData();
    },

    handlePageSizeChange(size) {
      this.pageSize = size;
      this.page = 1;
      this.getUserData();
    },

    getColor(calories) {
      if (calories === "Inactive") return "red";
      else return "green";
    },

    onlyNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if (keyCode < 48 || keyCode > 57) {
        // 46 is dot
        $event.preventDefault();
      }
    },

    getUserData() {
      this.loading = true;
      const params = this.getRequestParams(this.page, this.pageSize);
      this.loading = true;
      this.$httpSecured
        .get("/api/v1/warehouse/users", {
          params: { page: params["page"], per_page: params["size"] },
        })
        .then((response) => {
          if (response.data) {
            this.table_data = response.data.users;
            this.loading = false;
            this.totalPages = response.data.meta.total_pages;
            this.totalCount = response.data.meta.total_count;
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch((error) => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
        });
    },

    searchItem() {
      this.loading = true;
      const params = this.getRequestParams(this.page, this.pageSize);

      if (this.search.length !== 0) {
        this.$httpSecured
          .get("/api/v1/warehouse/users", {
            params: { page: 1, per_page: params["size"], search: this.search },
          })
          .then((response) => {
            if (response.data) {
              this.table_data = response.data.users;
              this.loading = false;
              this.totalPages = response.data.meta.total_pages;
              this.totalCount = response.data.meta.total_count;
            } else {
              this.showAlert("error", "No Records Found for given value");
            }
          })
          .catch(() =>
            this.showAlert("error", "Error in fetching Filter Record"),
          );
      } else {
        this.loading = false;
        this.getUserData();
      }
    },

    showAlert(alertType, alertMessage) {
      this.scrollToTop();
      this.alert = true;
      this.alert_type = alertType;
      this.alert_message = alertMessage;
      this.alertTimeOut();
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    },
    customSort: function (items, index, isDesc) {
      items.sort((a, b) => {
        if (index[0] === "both_ageing") {
          if (!isDesc[0]) {
            return (
              parseInt(b.ageing_dispatch.split(" ")[0]) -
              parseInt(a.ageing_dispatch.split(" ")[0])
            );
          } else {
            return (
              parseInt(a.ageing_dispatch.split(" ")[0]) -
              parseInt(b.ageing_dispatch.split(" ")[0])
            );
          }
        } else {
          if (typeof a[index] !== "undefined") {
            if (!isDesc[0]) {
              return a[index]
                .toLowerCase()
                .localeCompare(b[index].toLowerCase());
            } else {
              return b[index]
                .toLowerCase()
                .localeCompare(a[index].toLowerCase());
            }
          }
        }
      });
      return items;
    },
  },
  filters: {
    truncate: function (text, length, suffix) {
      if ((text ? text.length : 0) > length) {
        return text.substring(0, length) + suffix;
      } else {
        return text;
      }
    },
  },
};
</script>
<style scoped>
.theme--light.v-icon {
  color: #1867c0 !important;
}

.v-data-table > .v-data-table__wrapper > table > tbody > tr > th,
.v-data-table > .v-data-table__wrapper > table > thead > tr > th,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > th {
  font-size: 14px !important;
}
/* .v-card {
  max-width: 97% !important;
} */

.v-card-100 {
  max-width: 100% !important;
}
.inc-title {
  color: #172b4d;
  font-size: 20px;
}
.insurance-submission-table {
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 4px;
}
.v-data-table {
  height: calc(var(--vh, 1vh) * 100 - 305px) !important;
} 
</style>
